import { render, staticRenderFns } from "./AddActivity.vue?vue&type=template&id=276ad1a2&scoped=true"
import script from "./AddActivity.vue?vue&type=script&lang=js"
export * from "./AddActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276ad1a2",
  null
  
)

export default component.exports